module.exports = "/static/Images/en/Unsatisfied.png";